<template>
    <section class="d-flex flex-column h-full">
        <TopAppBar
            :leftBtnMode="leftBtnMode"
            :rightBtnMode="rightBtnMode"
            :title="title"
            :leftBtnMethod="leftBtnMethod"
            :rightBtnMethod="rightBtnMethod"
            staticMode="true"
        >
        </TopAppBar>
        <div class="flex-grow-1 scroll-y">
            <degree-list></degree-list>
        </div>
    </section>
</template>

<script>
/**
 * 전체 차수 메인 컴포넌트degree main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '../mixins/topAppBar.js'
import DegreeList from '../components/degree/List.vue'

export default {
    name: 'degree',
    data() {
        return {
        }
    },
    components: {
        TopAppBar, 
        'degree-list': DegreeList
    },

    mixins: [topAppBarMixin],

    mounted() {
        this.setTopAppBarBackSearch(this.$t('865'))
    },
}
</script>
